<h6 mat-dialog-title class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
  {{ sysText.pendingChanges_title | titlecase }}
</h6>

<mat-dialog-content>
  <p class="body2">
    {{ sysText.pendingChanges_message }}
  </p>
  <div class="pending-container">
    <p class="body2">
      {{ sysText.pendingChanges_title + ": " + actionsCount }}
    </p>
    @if (this.actionsCount != 0) {
      <mat-spinner diameter="18" color="accent"></mat-spinner>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button class="button" [mat-dialog-close]="false" color="accent">
    {{ sysText.cancel }}
  </button>
</mat-dialog-actions>
